import { Alert, Collapse } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { useSync } from '../shared/contexts/SyncContext';

export const OfflineBanner: React.FC = () => {
  const { isOnline, lastSyncedAt } = useSync();

  const cachedDate = lastSyncedAt
    ? lastSyncedAt.toLocaleString('en-GB', {
        day: '2-digit', month: '2-digit', year: '2-digit',
        hour: '2-digit', minute: '2-digit',
      })
    : 'never';

  return (
    <Collapse in={!isOnline}>
      <Alert
        icon={<WifiOffIcon fontSize="small" />}
        severity="warning"
        sx={{ borderRadius: 0, py: 0.5, fontSize: '0.82rem' }}
      >
        You are offline — showing data cached {cachedDate}. PDF generation uses cached photos.
      </Alert>
    </Collapse>
  );
};

export default OfflineBanner;
